export default class HeroHeaderAngle {
    constructor($hero) {
        this.$hero = $hero;
        this.$shape = $hero.querySelector('.hero-header-block__shape, .location-detail-block__overlay, .offer-detail-block__shape');
        this.$headerBar = document.querySelector('[data-site-header] .header__bar');
        this.$page = document.body.classList.contains('page--has-hero-header')
            ? document.body
            : document.documentElement;
        this.desktopQuery = window.matchMedia('(min-width: 992px)');
        this.frame = null;
        this.resizeObserver = null;

        if (!this.$shape || !this.$headerBar) {
            return;
        }

        this.handleChange = this.handleChange.bind(this);
        this.update = this.update.bind(this);

        this.bindEvents();
        this.handleChange();
    }

    /* -- INIT -- */

    bindEvents() {
        window.addEventListener('resize', this.handleChange, { passive: true });
        window.addEventListener('load', this.handleChange, { passive: true });

        if (typeof this.desktopQuery.addEventListener === 'function') {
            this.desktopQuery.addEventListener('change', this.handleChange);
        } else {
            this.desktopQuery.addListener(this.handleChange);
        }

        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(this.handleChange);
        }

        if (typeof ResizeObserver !== 'undefined') {
            this.resizeObserver = new ResizeObserver(this.handleChange);
            this.resizeObserver.observe(this.$headerBar);
            this.resizeObserver.observe(this.$hero);
        }
    }

    /* -- UPDATE -- */

    handleChange() {
        if (this.frame) {
            window.cancelAnimationFrame(this.frame);
        }

        this.frame = window.requestAnimationFrame(this.update);
    }

    update() {
        this.frame = null;

        if (!this.desktopQuery.matches) {
            this.$page.style.removeProperty('--header-hero-visual-run');
            return;
        }

        const headerRect = this.$headerBar.getBoundingClientRect();
        const shapeRect = this.$shape.getBoundingClientRect();
        const headerClipPath = window.getComputedStyle(this.$headerBar, '::before').clipPath;
        const points = this.getClipPathPoints(headerClipPath, headerRect);

        if (
            points.length < 4
            || points[0].x === null
            || points[3].x === null
            || headerRect.height <= 0
            || shapeRect.height <= 0
        ) {
            return;
        }

        const edgeRun = points[3].x - points[0].x;
        const shapeOffset = headerRect.left - shapeRect.left;
        const visualRun = edgeRun * (shapeRect.height / headerRect.height);

        this.$page.style.setProperty('--header-hero-shape-offset', `${shapeOffset.toFixed(3)}px`);
        this.$page.style.setProperty('--header-hero-visual-run', `${visualRun.toFixed(3)}px`);
    }

    getClipPathPoints(value, referenceRect) {
        if (!value || value === 'none') {
            return [];
        }

        const polygon = value.match(/^polygon\((.*)\)$/);

        if (!polygon) {
            return [];
        }

        return polygon[1]
            .split(',')
            .map((point) => {
                const [x, y] = point.trim().split(/\s+/);

                return {
                    x: this.parseCoordinateValue(x, referenceRect.width),
                    y: this.parseCoordinateValue(y, referenceRect.height),
                };
            });
    }

    parseCoordinateValue(value, referenceLength) {
        if (!value) {
            return null;
        }

        if (value === '0') {
            return 0;
        }

        if (value.endsWith('px')) {
            return parseFloat(value);
        }

        if (value.endsWith('%')) {
            return (parseFloat(value) / 100) * referenceLength;
        }

        return null;
    }
}
